'use strict';

const IPC = require('./services/IPC.js');

class IPCModule extends IPC{
    constructor(){
        super();
        //include IPC to make extensible
        Object.defineProperty(
            this,
            'IPC',
            {
                enumerable:true,
                writable:false,
                value:IPC
            }
        )
    }
}

module.exports=new IPCModule;



//////////////////
// WEBPACK FOOTER
// ./~/node-ipc/node-ipc.js
// module id = 177
// module chunks = 0 1